export class OrganizationStatuses {
  id = 0;

  name = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }

  static INACTIVE = 3;

  static toSelectable(items: OrganizationStatuses[]) {
    return items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));
  }
}

export default OrganizationStatuses;
